
class RecentlyViewedTracker {
  constructor() {
    this.init();
  }

  init() {
    if (window.productData && window.productData.handle) {
      this.trackProduct();
    }
    console.log('[RecentlyViewedTracker] productData:', window.productData);
  }

  trackProduct() {
    const productHandle = String(window.productData.handle || '').trim();

    if (!productHandle) {
      console.warn('[RecentlyViewedTracker] Missing product handle, skipping track.');
      return;
    }

    console.log('[RecentlyViewedTracker] Current product handle:', productHandle);

    let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');
    console.log('[RecentlyViewedTracker] Existing recently viewed:', recentlyViewed);

    // Remove current if exists
    recentlyViewed = recentlyViewed.filter((h) => h !== productHandle);

    // Add to front
    recentlyViewed.unshift(productHandle);

    // Keep last 20
    if (recentlyViewed.length > 20) recentlyViewed = recentlyViewed.slice(0, 20);

    localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));

    this.dispatchTrackingEvent(productHandle, recentlyViewed);
  }

  dispatchTrackingEvent(productHandle, productList) {
    const event = new CustomEvent('recently-viewed-updated', {
      detail: {
        productHandle,
        productList,
        timestamp: new Date().toISOString(),
      },
    });
    window.dispatchEvent(event);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new RecentlyViewedTracker());
} else {
  new RecentlyViewedTracker();
}
